export default "__VITE_ASSET__CEpXr26c__"